let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("giy0q")).then(() => parcelRequire('2PQGe'));